/**
*字符串工具类
*/
/*eslint-disable */
const stringTooles = {
  cellContentSub (value) {
    if (!value) {
      return '无'
    }
    const length = 10
    if (value.length > 10) {
      return value.substring(0, length) + '...'
    }
    return value
  },
  // 编号不够6位自动补全
  completeNo (val) {
    let value = val.toString()
    if (val === 0) {
      value = null
    } else {
      while (value.length < 6) {
        value = '0' + value
      }
    }
    return value
  },
  // 字符串变base64
  strToBase64(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    // public method for encoding
    var output = ""
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0
    input = stringTooles.utf8Encode(input)
    while (i < input.length) {
        chr1 = input.charCodeAt(i++)
        chr2 = input.charCodeAt(i++)
        chr3 = input.charCodeAt(i++)
        enc1 = chr1 >> 2
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
        enc4 = chr3 & 63
        if (isNaN(chr2)) {
            enc3 = enc4 = 64
        } else if (isNaN(chr3)) {
            enc4 = 64
        }
        output = output +
        keyStr.charAt(enc1) + keyStr.charAt(enc2) +
        keyStr.charAt(enc3) + keyStr.charAt(enc4)
    }
    return output
  },
  utf8Encode(string) {
      string += ''
      string = string.replace(/\r\n/g,"\n")
      var utftext = ""
      for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n)
          if (c < 128) {
              utftext += String.fromCharCode(c)
          } else if((c > 127) && (c < 2048)) {
              utftext += String.fromCharCode((c >> 6) | 192)
              utftext += String.fromCharCode((c & 63) | 128)
          } else {
              utftext += String.fromCharCode((c >> 12) | 224)
              utftext += String.fromCharCode(((c >> 6) & 63) | 128)
              utftext += String.fromCharCode((c & 63) | 128)
          }
      }
      return utftext
  }
}
export default stringTooles
